import { Route, Routes, Navigate } from "react-router-dom";
import { RequireAuthWrapper } from "../pages/RequireAuthWrapper";
import { AppLayout } from "../components/containers/appLayout/AppLayout";
import { HumanInTheLoop } from "../pages/humanInTheLoopPage";
import { UrlList } from "../pages/humanInTheLoopPage/urlList";
import { PastReview } from "../pages/humanInTheLoopPage/pastReview";
import { PredictiveCorrection } from "../pages/humanInTheLoopPage/predictiveCorrections/index";
import { UrlReview } from "../pages/humanInTheLoopPage/urlReview";

export const HumanInTheLoopRoutes = () => {
  return (
    <Routes>
      <Route
        path={""}
        element={
          <RequireAuthWrapper>
            <AppLayout pageTitle={"Human in the Loop"}>
              <HumanInTheLoop />
            </AppLayout>
          </RequireAuthWrapper>
        }
      >
        <Route
          path={""}
          element={<Navigate to={"url-list"} replace={true} />}
        />

        
        <Route
          path={"url-list"}
          element={
            <RequireAuthWrapper>
              <UrlList />
            </RequireAuthWrapper>
          }
        />
        <Route path={":url"}>
        <Route
          path={"review"}
          element={
            <RequireAuthWrapper>
              <UrlReview />
            </RequireAuthWrapper>
          }
        />

        <Route
          path={"past-review"}
          element={
            <RequireAuthWrapper>
              <PastReview />
            </RequireAuthWrapper>
          }
        />

        <Route
          path={"predictive-correction"}
          element={
            <RequireAuthWrapper>
              <PredictiveCorrection />
            </RequireAuthWrapper>
          }
        />
      </Route>
      </Route>
    </Routes>
  );
};

